import React from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import ProtectedRoute from "./components/ProtectedRoute/ProtectedRoute";

//Pages
import Dashboard from "./pages/Dashboard/Dashboard";
import Error from "./pages/Error/Error";
import { RutaBase } from "./Utils/Funciones";
import NotFound from "./pages/NotFound";
import Inicio from "./pages/Inicio/Inicio";
import NoAcceso from "./pages/NoAcceso/NoAcceso";
import SesionDesconectada from "./pages/SesionDesconectada/SesionDesconectada";

const Routes = () => {

    return(
        <BrowserRouter basename="/ciudadano">
            <Switch>
                <ProtectedRoute exact path={RutaBase(true)+"/"} component={Inicio} />
                <ProtectedRoute exact path={RutaBase(true)+"/Inicio/"} component={Inicio} />
                <Route exact path={RutaBase(true)+"/Dashboard/"} component={Dashboard} />
                <Route exact path={RutaBase(true)+"/Error/"} component={Error} />
                <Route exact path={RutaBase(true)+"/NoAcceso/"} component={NoAcceso} />
                <Route exact path={RutaBase(true)+"/SesionDesconectada/"} component={SesionDesconectada} />
                <Route component={NotFound} />
            </Switch>
        </BrowserRouter>
    );
}

export default Routes;
